// extracted by mini-css-extract-plugin
module.exports = {"startSeparator":"PoolDetail_startSeparator__3zVyM","endSeparator":"PoolDetail_endSeparator__3PznR"};